/**
 * Utility functions for page detection and routing
 */

/**
 * List of public pages where user authentication is not required
 */
const PUBLIC_PAGES = [
  '/sign-in',
  '/sign-up',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
  '/terms-of-service',
  '/privacy-policy',
  '/public',
  '/',
];

/**
 * List of auth pages where API calls should be minimal
 */
const AUTH_PAGES = [
  '/sign-in',
  '/sign-up',
  '/forgot-password',
  '/reset-password',
  '/verify-email',
];

/**
 * Check if the current path is a public page
 */
export function isPublicPage(pathname: string): boolean {
  if (!pathname) return false;
  
  return PUBLIC_PAGES.some(page => {
    if (page === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(page);
  });
}

/**
 * Check if the current path is an authentication page
 */
export function isAuthPage(pathname: string): boolean {
  if (!pathname) return false;
  
  return AUTH_PAGES.some(page => pathname.startsWith(page));
}

/**
 * Check if the current path requires authentication
 */
export function requiresAuth(pathname: string): boolean {
  return !isPublicPage(pathname);
}

/**
 * Check if API calls should be made on this page
 */
export function shouldMakeApiCalls(pathname: string): boolean {
  // Don't make API calls on auth pages to avoid unnecessary requests
  return !isAuthPage(pathname);
}

export default {
  isPublicPage,
  isAuthPage,
  requiresAuth,
  shouldMakeApiCalls,
};